import React from "react";
import { Stack, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderContainer, BackButton, ActionIconButton, CloseButton, Divider } from "./styled";
import { dumontColors } from "../../colors";
import { BackIcon, ChatIconHeader, MaximizeIcon, CloseIconCustom, MinimizeIcon } from "Components/DumontSidebar/CustomIcons";

export interface HeaderControlsProps {
  showBackHistory?: boolean;
  showBackAgents?: boolean;
  showBackDispatch?: boolean;
  onBackHistory?: () => void;
  onBackAgents?: () => void;
  onBackDispatch?: () => void;
  onNewChat: () => void;
  onOpenNewWindow?: () => void;
  onRequestFullPage?: () => void;
  onExitFullscreenToTab?: () => void;
  onClose: () => void;
  isFullscreen?: boolean;
}

export default function HeaderControls({
  showBackHistory,
  showBackAgents,
  showBackDispatch,
  onBackHistory,
  onBackAgents,
  onBackDispatch,
  onNewChat,
  onOpenNewWindow,
  onRequestFullPage,
  onExitFullscreenToTab,
  onClose,
  isFullscreen,
}: HeaderControlsProps) {
  const { t: translate } = useTranslation();
  const showBackButton = showBackHistory || showBackAgents || showBackDispatch;
  const handleBackClick = showBackHistory ? onBackHistory : showBackAgents ? onBackAgents : onBackDispatch;

  return (
    <>
    {isFullscreen ? (
      <></>
    ) : (
      <>
        <HeaderContainer isFullscreen={isFullscreen} showBackButton={!!showBackButton}>
        {showBackButton && (
          <BackButton size="small" onClick={handleBackClick}>
            <BackIcon sx={{ fontSize: 16, color: dumontColors.textTertiary }} />
          </BackButton>
        )}

        <Stack direction="row" spacing={1}>  
            <Tooltip title={translate("dumontNewChat")} placement="bottom">
              <ActionIconButton size="small" onClick={onNewChat}>
                <ChatIconHeader sx={{ fontSize: 14, color: dumontColors.textTertiary }} />
              </ActionIconButton>
            </Tooltip>

            <Tooltip title={translate("dumontOpenInNewWindow")} placement="bottom">
              <ActionIconButton
                size="small"
                onClick={onRequestFullPage ?? onOpenNewWindow}
                disabled={!onRequestFullPage && !onOpenNewWindow}
              >
                <MaximizeIcon sx={{ fontSize: 16, color: dumontColors.textTertiary }} />
              </ActionIconButton>
            </Tooltip>

          <Tooltip title={translate("dumontCloseShortcut")} placement="bottom">
            <CloseButton onClick={onClose}>
              <CloseIconCustom sx={{ fontSize: 16, color: dumontColors.textTertiary }} />
              <Divider />
              <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#989CA4", fontFamily: "Manrope", lineHeight: 1.4 }}>
                ⌘K
              </Typography>
            </CloseButton>
          </Tooltip>
        </Stack>
      </HeaderContainer>
      </>
    )}
    </>
  );
}
